import { billingTypes } from '../constants';

export default function getAggregatedExpectedRevenue(data) {
  return data.reduce((sum, opportunity) => {
    if (
      opportunity.billingType ===
      billingTypes.find(type => type.value === 'Test').value
    ) {
      return sum;
    }
    const expectedRevenue = opportunity.expectedRevenue || 0;
    return sum + expectedRevenue;
  }, 0);
}
